module.exports = __webpack_public_path__ + "media/images/breadcrump_icon-5613eeef3311a2672cca3980c8199a26.svg";